export const specialCharacterCodeConstants = [
    { 'character':' ', 'code':'%20'},
    { 'character':'!', 'code':'%21'},
    { 'character':'"', 'code':'%22'},
    { 'character':'#', 'code':'%23'},
    { 'character':'$', 'code':'%24'},
    { 'character':'%', 'code':'%25'},
    { 'character':'&', 'code':'%26'},
    { 'character':"'", 'code':'%27'},
    { 'character':'(', 'code':'%28'},
    { 'character':')', 'code':'%29'},
    { 'character':'*', 'code':'%2A'},
    { 'character':'+', 'code':'%2B'},
    { 'character':',', 'code':'%2C'},
    { 'character':'-', 'code':'%2D'},
    { 'character':'.', 'code':'%2E'},
    { 'character':'/', 'code':'%2F'},
    { 'character':':', 'code':'%3A'},
    { 'character':';', 'code':'%3B'},
    { 'character':'<', 'code':'%3C'},
    { 'character':'=', 'code':'%3D'},
    { 'character':'>', 'code':'%3E'},
    { 'character':'?', 'code':'%3F'},
    { 'character':'@', 'code':'%40'},
    { 'character':'[', 'code':'%5B'},
    { 'character':"\/", 'code':'%5C'},
    { 'character':'}', 'code':'%5D'},
    { 'character':'^', 'code':'%5E'},
    { 'character':'_', 'code':'%5F'},
    { 'character':'`', 'code':'%60'},
    { 'character':'{', 'code':'%7B'},
    { 'character':'|', 'code':'%7C'},
    { 'character':'}', 'code':'%7D'},
    { 'character':'~', 'code':'%7E'},
    { 'character':'€', 'code':'%80'},
    { 'character':'', 'code':'%81'},
    { 'character':'‚', 'code':'%82'},
    { 'character':'ƒ', 'code':'%83'},
    { 'character':'„', 'code':'%84'},
    { 'character':'…', 'code':'%85'},
    { 'character':'†', 'code':'%86'},
    { 'character':'‡', 'code':'%87'},
    { 'character':'ˆ', 'code':'%88'},
    { 'character':'‰', 'code':'%89'},
    { 'character':'Š', 'code':'%8A'},
    { 'character':'‹', 'code':'%8B'},
    { 'character':'Œ', 'code':'%8C'},
    { 'character':'Ž', 'code':'%8E'},
    { 'character':'‘', 'code':'%91'},
    { 'character':'’', 'code':'%92'},
    { 'character':'“', 'code':'%93'},
    { 'character':'”', 'code':'%94'},
    { 'character':'•', 'code':'%95'},
    { 'character':'–', 'code':'%96'},
    { 'character':'—', 'code':'%97'},
    { 'character':'˜', 'code':'%98'},
    { 'character':'™', 'code':'%99'},
    { 'character':'š', 'code':'%9A'},
    { 'character':'›', 'code':'%9B'},
    { 'character':'œ', 'code':'%9C'},
    { 'character':'ž', 'code':'%9E'},
    { 'character':'Ÿ', 'code':'%9F'},
    { 'character':'¡', 'code':'%A1'},
    { 'character':'¢', 'code':'%A2'},
    { 'character':'£', 'code':'%A3'},
    { 'character':'¤', 'code':'%A4'},
    { 'character':'¥', 'code':'%A5'},
    { 'character':'¦', 'code':'%A6'},
    { 'character':'§', 'code':'%A7'},
    { 'character':'¨', 'code':'%A8'},
    { 'character':'©', 'code':'%A9'},
    { 'character':'ª', 'code':'%AA'},
    { 'character':'«', 'code':'%AB'},
    { 'character':'¬', 'code':'%AC'},
    { 'character':'­', 'code':'%AD'},
    { 'character':'®', 'code':'%AE'},
    { 'character':'¯', 'code':'%AF'},
    { 'character':'°', 'code':'%B0'},
    { 'character':'±', 'code':'%B1'},
    { 'character':'²', 'code':'%B2'},
    { 'character':'³', 'code':'%B3'},
    { 'character':'´', 'code':'%B4'},
    { 'character':'µ', 'code':'%B5'},
    { 'character':'¶', 'code':'%B6'},
    { 'character':'·', 'code':'%B7'},
    { 'character':'¸', 'code':'%B8'},
    { 'character':'¹', 'code':'%B9'},
    { 'character':'º', 'code':'%BA'},
    { 'character':'»', 'code':'%BB'},
    { 'character':'¼', 'code':'%BC'},
    { 'character':'½', 'code':'%BD'},
    { 'character':'¾', 'code':'%BE'},
    { 'character':'¿', 'code':'%BF'},
    { 'character':'À', 'code':'%C0'},
    { 'character':'Á', 'code':'%C1'},
    { 'character':'Â', 'code':'%C2'},
    { 'character':'Ã', 'code':'%C3'},
    { 'character':'Ä', 'code':'%C4'},
    { 'character':'Å', 'code':'%C5'},
    { 'character':'Æ', 'code':'%C6'},
    { 'character':'Ç', 'code':'%C7'},
    { 'character':'È', 'code':'%C8'},
    { 'character':'É', 'code':'%C9'},
    { 'character':'Ê', 'code':'%CA'},
    { 'character':'Ë', 'code':'%CB'},
    { 'character':'Ì', 'code':'%CC'},
    { 'character':'Í', 'code':'%CD'},
    { 'character':'Î', 'code':'%CE'},
    { 'character':'Ï', 'code':'%CF'},
    { 'character':'Ð', 'code':'%D0'},
    { 'character':'Ñ', 'code':'%D1'},
    { 'character':'Ò', 'code':'%D2'},
    { 'character':'Ó', 'code':'%D3'},
    { 'character':'Ô', 'code':'%D4'},
    { 'character':'Õ', 'code':'%D5'},
    { 'character':'Ö', 'code':'%D6'},
    { 'character':'×', 'code':'%D7'},
    { 'character':'Ø', 'code':'%D8'},
    { 'character':'Ù', 'code':'%D9'},
    { 'character':'Ú', 'code':'%DA'},
    { 'character':'Û', 'code':'%DB'},
    { 'character':'Ü', 'code':'%DC'},
    { 'character':'Ý', 'code':'%DD'},
    { 'character':'Þ', 'code':'%DE'},
    { 'character':'ß', 'code':'%DF'},
    { 'character':'à', 'code':'%E0'},
    { 'character':'á', 'code':'%E1'},
    { 'character':'â', 'code':'%E2'},
    { 'character':'ã', 'code':'%E3'},
    { 'character':'ä', 'code':'%E4'},
    { 'character':'å', 'code':'%E5'},
    { 'character':'æ', 'code':'%E6'},
    { 'character':'ç', 'code':'%E7'},
    { 'character':'è', 'code':'%E8'},
    { 'character':'é', 'code':'%E9'},
    { 'character':'ê', 'code':'%EA'},
    { 'character':'ë', 'code':'%EB'},
    { 'character':'ì', 'code':'%EC'},
    { 'character':'í', 'code':'%ED'},
    { 'character':'î', 'code':'%EE'},
    { 'character':'ï', 'code':'%EF'},
    { 'character':'ð', 'code':'%F0'},
    { 'character':'ñ', 'code':'%F1'},
    { 'character':'ò', 'code':'%F2'},
    { 'character':'ó', 'code':'%F3'},
    { 'character':'ô', 'code':'%F4'},
    { 'character':'õ', 'code':'%F5'},
    { 'character':'ö', 'code':'%F6'},
    { 'character':'÷', 'code':'%F7'},
    { 'character':'ø', 'code':'%F8'},
    { 'character':'ù', 'code':'%F9'},
    { 'character':'ú', 'code':'%FA'},
    { 'character':'û', 'code':'%FB'},
    { 'character':'ü', 'code':'%FC'},
    { 'character':'ý', 'code':'%FD'},
    { 'character':'þ', 'code':'%FE'},
    { 'character':'ÿ', 'code':'%FF'}
];

export const shareProjectDocumentsOptions = [
    {'id': 'Do not share','name':'','is_project_first_contact': false,'is_contact':false},
    {'id': 'Anyone with link','name':'Anyone with link','is_project_first_contact': false,'is_contact':false},
    {'id': 'With company','name':'With company','is_project_first_contact': false,'is_contact':false},
];

export const completePercentageConstants = [
    '5%',
    '10%',
    '15%',
    '20%',
    '25%',
    '30%',
    '35%',
    '40%',
    '45%',
    '50%',
    '55%',
    '60%',
    '65%',
    '70%',
    '75%',
    '80%',
    '85%',
    '90%',
    '95%',
    '100%'
];
